export const NEW_GAME_SOCKET = 'NEW_GAME_SOCKET';
export const newGameSocket = (socket, payload)=>({
    type: NEW_GAME_SOCKET,
    socket,
    payload
});

export const REFRESH_ROOMS_LIST_SOCKET = 'REFRESH_ROOMS_LIST_SOCKET';
export const refreshRoomsListSocket = (socket)=>({
    type: REFRESH_ROOMS_LIST_SOCKET,
    socket
});

export const REFRESH_ROOMS_LIST_LOCAL = 'REFRESH_ROOMS_LIST_LOCAL';
export const refreshRoomsListLocal = (payload) =>({
    type: REFRESH_ROOMS_LIST_LOCAL,
    payload
});

export const JOIN_GAME_SOCKET = "JOIN_GAME_SOCKET";
export const joinGameSocket = (socket, payload)=> ({
    type: JOIN_GAME_SOCKET,
    socket,
    payload,
});

export const LEAVE_GAME_SOCKET = 'LEAVE_GAME_SOCKET';
export const leaveGameSocket = (payload)=>({
    type: LEAVE_GAME_SOCKET,
    payload
});

export const RESET_GAMEMNGT_STATE = 'RESET_GAMEMNGT_STATE';
export  const resetGameMngtState = () =>({
    type: RESET_GAMEMNGT_STATE
});


// WEBPACK FOOTER //
// ./src/actions/gameManagement.js